module.exports = function Aux (props) {
  return props.children;
};



//////////////////
// WEBPACK FOOTER
// ./~/react-aux/src/Aux.js
// module id = 215
// module chunks = 107818501498521 114276838955818